import { render } from "./config-plan.vue?vue&type=template&id=e1142162"
import script from "./config-plan.vue?vue&type=script&lang=jsx"
export * from "./config-plan.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__